import type { PostPlacementInstance } from "building-types/settings/railingTypes";

export enum SegmentEndType {
  POST = "POST",
  BALUSTER = "BALUSTER",
}

export interface InfillSegment {
  readonly edgeIndex: number;
  readonly startParam: number;
  readonly startType: SegmentEndType;
  readonly endParam: number;
  readonly endType: SegmentEndType;
  readonly endShouldPlaceInfill: boolean; // most the time the end is placed by the next segment
  readonly spanIncludesInfill: boolean;
}

export interface PostInfillControlPoints {
  // resolved on first pass
  readonly edgeIndex: number;
  readonly param: number;
  /**
   * any posts at the same position get grouped here, this is an empty array if the railing
   * changes direction without a post.
   **/
  readonly postPlacements: PostPlacementInstance[];

  //resolved on second optimization pass
  hasPost?: boolean;
  removeInfillBefore?: boolean;
  removeInfillAfter?: boolean;

  //resolved on third marching pass
  hasInfill?: boolean;
}
